<template>
    <div class="page">
    <header style="">
        <b-navbar toggleable="lg" type="dark"  style="background:#666;padding-left:5%;position:sticky;width:100%;z-index:999;position: -webkit-sticky;" >
        <!-- <b-navbar-brand href="#" style="font-size:30px"><img src="../../static/images/logo2.png" alt=""></b-navbar-brand> -->
        <b-navbar-brand href="#" style="font-size:30px;margin-right:0"><b-img :src=Logo.src  class="corpLogo" style="margin-left:30px;margin-right:60px">

                  </b-img></b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav id="nav">
            <b-nav-item to="/">{{$t("common.home")}}</b-nav-item>
            <b-nav-item to="/Desc" >{{$t("common.corp")}}</b-nav-item>
            <b-nav-item to="/product" >{{$t("common.product")}}</b-nav-item>
            <b-nav-item to="/news" >
            
                {{$t("Home.newsTitle")}}
            </b-nav-item>
            <!-- <b-nav-item  ><router-link to="/news">{{$t("common.news")}}</router-link></b-nav-item> -->
            
            <!-- <b-nav-item href="#" >视频专栏</b-nav-item> -->
            
            <b-nav-item to="/contact" >{{$t("common.contact")}}</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
            <!-- <b-nav-form>
            <b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
            <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
            </b-nav-form> -->

            <b-nav-item-dropdown text="Language/语言切换" right  class="langbtn " style="color:#fff">
            <b-dropdown-item href="#" @click="changeToEN">EN</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeToCN">CN</b-dropdown-item>
            
            </b-nav-item-dropdown>

            
        </b-navbar-nav>
        </b-collapse>
    </b-navbar>
    </header>
        
        <div style="" class="main-con">
            <router-view></router-view>
        </div>
        <!-- <div>
            <footbanner/>  
        </div> -->
        
            <info :class="{'is_fixed':isFixed}" id="infoBox"  ref="infomationBox" style=""/>
        
        <div style="position:relative;">
            <v-footer></v-footer> 
        </div>
        <!-- <footer class="footer navbar-fixed-bottom ">
            <div class="fcontainer">
                footer
            </div>
        </footer> -->
    </div>
</template>
<script>
import Piofooter from './footer'
import info from './infoBox'
import footbanner from '../views/footbanner.vue'
export default {
     components: {
            
            'v-footer':Piofooter,
            footbanner,
            info
          },
    data() {
        return {
            meal: '',
            Logo:
          {
            src: require('../../static/Updatedimg/logo-new.png')
          },
          roll:'',
          boxTop:'',
          isFixed:false,
        }
    },
  methods: {
    changeToEN(){
        this.$i18n.locale = "en"
        // console.log(this.$i18n.locale)
    },
    changeToCN(){
        this.$i18n.locale = "zh"
        // console.log(this.$i18n.locale)
    },
    handleScroll () {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    this.roll = scrollTop
    let BoxTop = document.querySelector('#infoBox').offsetTop
    // console.log(this.roll,this.boxTop)
    // console.log(this.isFixed)
    this.boxTop = BoxTop
    // scrollTop>BoxTop?this.isFixed = true:this.isFixed = false
    if(this.roll>80){
        this.$refs.infomationBox.$refs.Box.style.top = this.roll+80+"px"
        // console.log(this.$refs.infomationBox.$refs.Box.style.top)
    }
    else{
        this.$refs.infomationBox.$refs.Box.style.top = 80+"px"
    }
    },

  },
  mounted () {
  window.addEventListener('scroll', this.handleScroll)
},
    // computed:{
	// 		// 滑动bar置顶
	// 		namepage(){
	// 			if(this.roll>this.boxTop){
	// 					this.isFixed = true
	// 			}
	// 			else{
	// 					this.isFixed = false
	// 			}
	// 		}
	// 	},
}    
</script>

<style>
.is_fixed{
		position: fixed !important;
		right: 0;
        margin: 0 40px;
		opacity: .8;
        top:5px;
	}
.corpLogo{
    width:250px;
}
@media (max-width: 500px) {
   .corpLogo{
    width:160px;
    
} 
    #infoBox{
        display: none;
    }
    /* .main-con{
        top: 67.75px !important;
    } */
}
.drop-nav{
    font-size: 16px !important;
    font-weight: 600;
    color: #fff
}
    .footer{
    width: 100%;
    position:relative;
    /* margin: 0 auto; */
    bottom:0;
    height:50px;
    z-index: 99;
    background: #1475c4;
    

    }
    .page{
        background: whitesmoke
    }
    #nav  .nav-item a{
        color: rgba(255, 255, 255, 1.0);
        font-size: 18px !important;
        text-decoration: none;
        font-weight: 600;
    }
    #nav .nav-item a:hover{
        color: rgba(255, 255, 255, 0.5);
        text-decoration: none;
    }
    .navbar-nav .nav-item {
       padding: 0 10px ;
    }
    .langbtn{
        color:rgba(255, 255, 255, 1.0) !important;
        font-size:18px !important;
        font-weight:600;
    }
    .dropdown-toggle span{
        color: #fff
    }
</style>
